import { useEffect } from "react";

// GoHighLevel / LeadConnector booking embed. Loads form_embed.js ONCE so the
// iframe auto-resizes; keeps the original widget iframe id intact.
// minHeight guards against a clipped calendar if the embed script is slow
// or blocked — the script overrides with the exact height once it runs.
export default function GhlCalendar({ src, scriptSrc, iframeId, title, className = "", testId }) {
  useEffect(() => {
    if (document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]')) return;
    const s = document.createElement("script");
    s.src = scriptSrc;
    s.type = "text/javascript";
    s.async = true;
    s.setAttribute("data-ghl-embed", "1");
    document.body.appendChild(s);
  }, [scriptSrc]);

  return (
    <iframe
      src={src}
      allow="payment"
      scrolling="no"
      id={iframeId}
      title={title}
      data-testid={testId}
      className={`w-full ${className}`}
      style={{ width: "100%", border: "none", overflow: "hidden", minHeight: "720px" }}
    />
  );
}
